export class monthlyreportFilterModel {   
    pageNumber: any;
    pageSize: any;    
    monthandyear: any;
    orderBy: any;
}